import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import DropPdfOrImage from 'components/dropZone/DropPdfOrImage';
import { ModalActionProps } from 'models/AutoModals';


type PriceConfirmationDialogProps = {
    title: string,
    url?: string,
} & ModalActionProps<File>

const UploadPDFDialog = ({title, url, onFinish}: PriceConfirmationDialogProps) => {
    const {t} = useTranslation();
    const [file, setFile] = useState<File | undefined>();

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        file && onFinish(file);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <DropPdfOrImage
                    upload={setFile}
                    title={title}
                    image={url ? {type: 'application/pdf', file: url} : undefined}
                />
            </DialogContent>

            {file &&
                <DialogActions>
                    <Button type="submit">{t('upload')}</Button>
                </DialogActions>
            }
        </Box>
    );
};

export default UploadPDFDialog;
